exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-443a00f5]{opacity:.25;pointer-events:none}", ""]);

// exports
